export default {
  isLogged: ({ logged }: any) => logged,
  isRegister: ({ completeRegister }: any) => completeRegister,
  isPaid: ({ statusPaid }: any) => statusPaid,
  eventData: ({ eventData }: any) => eventData,
  participantData: ({ participantData, participantGeneralData }: any) => {
    return { ...participantData, ...participantGeneralData };
  },
  getValidEvent: ({ eventData }: any) => (eventData ? true : false),
  data: ({ data }: any) => (Object.keys(data).length === 0 ? null : data),
  reservationRooms: ({ reservationRooms }: any) => reservationRooms,
  courses: ({ courses }: any) => courses,
  program: ({ program }: any) => program,
  status: ({ status }: any) => status,
  getBillingData: ({ billingData }: any) => billingData,
  activateCardRegister: ({ activateCardRegister }: any) => activateCardRegister,
  getOptionURLRegister: ({ eventData }: any) => {
    if (eventData) {
      if (eventData.optionalOnlineRegisterURL)
        return eventData.optionalOnlineRegisterURL;
      return "";
    }
    return "";
  },
  checkIfRegisterOnlineIsEnabled: ({ eventData }: any) => {
    const onlineRegister = eventData.eventFeatures.find(
      (el) => el.id === "online_registration"
    );
    if (!onlineRegister) return true;
    return onlineRegister.isSelected;
  },
  getBookings: ({ bookings }: any) => bookings,
  getBillings: ({ billings }: any) => billings,
};
